if(!customElements.get('flip-carousel')) {

  class ComponentProductIngredients extends HTMLElement {
    constructor() {
      super()  

      this.sliderElement = this.querySelector('.keen-slider');
      this.carouselMode = this.dataset.carouselMode;
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.carouselCenteredTablet = this.dataset.carouselCenteredTablet;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;

      this.paginateCurrent = this.querySelector('.current');
      this.paginateLength = this.querySelector('.length');
      this.flipLiveRegion = this.querySelector('[data-flip-live-region]');

      setTimeout(()=>{ //The timeout is for the customizer
        this.initSlider();
        this.neutralizeBgsetImages();
      }, 1);

      this.addEventListener('lazyloaded', (event) => {
        if (event.target?.classList?.contains('background-card')) {
          this.neutralizeBgsetInCard(event.target);
        }
      }, true);

      this.flipButtons = this.querySelectorAll('.flip-button');

      this.querySelectorAll('.card-inner').forEach((cardInner) => {
        this.updateFlipAccessibility(cardInner);
      });

      this.flipButtons.forEach(flipButton => {
        flipButton.addEventListener('click',()=>{
          var cardId = flipButton.getAttribute('data-card-id');
          var cardToFlip = this.querySelector(`#${cardId}`);
          const wasFlipped = cardToFlip.classList.contains('active');
          if(wasFlipped)
            cardToFlip.classList.remove('active');
          else 
            cardToFlip.classList.add('active');

          const isFlipped = cardToFlip.classList.contains('active');
          this.updateFlipAccessibility(cardToFlip);
          if (isFlipped !== wasFlipped) {
            this.announceFlip(cardToFlip, isFlipped);
          }
        });

        flipButton.addEventListener('focus', () => {
          const cardId = flipButton.getAttribute('data-card-id');
          const cardInner = this.querySelector(`#${cardId}`);
          if (cardInner) this.updateFlipAccessibility(cardInner);
        });
      })
    }

    getSideElement(cardInner, isBack) {
      const id = isBack ? cardInner.dataset.flipBackId : cardInner.dataset.flipFrontId;
      if (id) return document.getElementById(id);
      return cardInner.querySelector(isBack ? '.flip-description > div' : '.flip-name');
    }

    getSideText(element) {
      return element?.textContent?.replace(/\s+/g, ' ').trim() || '';
    }

    neutralizeBgsetInCard(card) {
      card.querySelectorAll('img, picture').forEach((el) => {
        el.setAttribute('aria-hidden', 'true');
        if (el.tagName === 'IMG') el.setAttribute('alt', '');
      });
    }

    neutralizeBgsetImages() {
      this.querySelectorAll('.background-card').forEach((card) => {
        this.neutralizeBgsetInCard(card);
      });
    }

    setFlipButtonLabel(button, showBackSide, cardName) {
      const action = showBackSide ? 'show back side' : 'show front side';
      const nameSuffix = cardName ? `, ${cardName}` : '';
      button.setAttribute('aria-label', `Flip card${nameSuffix}, ${action}`);
      button.removeAttribute('aria-labelledby');
      button.removeAttribute('aria-describedby');
    }

    updateFlipAccessibility(cardInner) {
      const isFlipped = cardInner.classList.contains('active');
      const cardFront = cardInner.querySelector('.card-front');
      const cardBack = cardInner.querySelector('.card-back');
      const frontButton = cardFront?.querySelector('.flip-button');
      const backButton = cardBack?.querySelector('.flip-button');
      const frontContent = this.getSideElement(cardInner, false);
      const backContent = this.getSideElement(cardInner, true);
      const frontName = this.getSideText(frontContent);

      if (cardFront) cardFront.setAttribute('aria-hidden', isFlipped ? 'true' : 'false');
      if (cardBack) cardBack.setAttribute('aria-hidden', isFlipped ? 'false' : 'true');

      if (frontContent) frontContent.setAttribute('aria-hidden', isFlipped ? 'true' : 'false');
      if (backContent) backContent.setAttribute('aria-hidden', isFlipped ? 'false' : 'true');

      if (frontButton) {
        frontButton.setAttribute('aria-pressed', isFlipped ? 'true' : 'false');
        frontButton.setAttribute('tabindex', isFlipped ? '-1' : '0');
        if (!isFlipped) {
          this.setFlipButtonLabel(frontButton, true, frontName);
        }
      }

      if (backButton) {
        backButton.setAttribute('aria-pressed', isFlipped ? 'true' : 'false');
        backButton.setAttribute('tabindex', isFlipped ? '0' : '-1');
        if (isFlipped) {
          this.setFlipButtonLabel(backButton, false, frontName);
        }
      }
    }

    announceFlip(cardInner, isFlipped) {
      if (!this.flipLiveRegion) return;
      const visibleEl = this.getSideElement(cardInner, isFlipped);
      const side = isFlipped ? 'Back side' : 'Front side';
      const text = this.getSideText(visibleEl);
      this.flipLiveRegion.textContent = text ? `${side}: ${text}` : `${side} of card now showing`;
    }

    handleMediaChange(){
      if($s.media.isLarge && this.currentMediaSize != 'large') {
        this.currentMediaSize = 'large';
        this.largeTarget.appendChild(this.galleryToMove);
        if(this.sliderObj)
          this.sliderObj.destroy();
        this.initSlider();      
      } 
      if($s.media.isMediumDown && this.currentMediaSize != 'medium') {
        this.currentMediaSize = 'medium';
        this.mediumTarget.appendChild(this.galleryToMove);
        if(this.sliderObj)
          this.sliderObj.destroy();
        this.initSlider();      
      }
    }

    initSlider() {
      this.sliderObj = new KeenSlider(this.sliderElement, {
        mode: this.carouselMode,
        loop: this.carouselLoop=="true",
        dots: this.querySelector('.keen-dots'),
        prevButton: this.querySelector('.keen-arrow.prev'),
        nextButton: this.querySelector('.keen-arrow.next'),
        slideCounter: this.querySelector('.paginate'),
        autoplay: this.carouselAutoplay,
        slideChanged: (keen)=>{
          var slides = keen.slides();
          this.paginateCurrent.textContent = slides.indexOf(keen.currentSlide())+1;
          this.paginateLength.textContent = slides.length;
          
        },
        breakpoints: {
          '(min-width: 1051px)': {
            centered: this.carouselCenteredDesktop=="true",
            spacing: this.carouselSpacingDesktop,
            slidesPerView: this.slidesPerViewDesktop
          },
          '(min-width: 601px) and (max-width: 1050px)': {
            centered: this.carouselCenteredTablet=="true",
            spacing: this.carouselSpacingTablet,
            slidesPerView: this.slidesPerViewTablet
          },
          '(max-width: 600px)': {
            centered: this.carouselCenteredMobile=="true",
            spacing: this.carouselSpacingMobile,
            slidesPerView: this.slidesPerViewMobile
          }
        }
      });
    }
  
  }
  customElements.define('flip-carousel', ComponentProductIngredients);

}
